import React, { Fragment, useEffect, useState } from "react";
import "../../../styles/common.css";
import { Outlet } from "react-router-dom";
import SideMenu from "./side-menu.jsx";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import { catchError } from '../../helpers/catch-error.jsx';
import logo from '../../../assets/images/logo-round.jpeg'


const Layout = () => {
  const navigate = useNavigate();
  const [isMini, setIsMini] = useState(false);

  useEffect(() => {
    document.title = process.env.REACT_APP_NAME + ": Administrator";
    console.log(localStorage.getItem('@user_email'));
    console.log(localStorage.getItem('@user_role'));

    if (!(localStorage.getItem('@user_email') && localStorage.getItem('@user_role') && localStorage.getItem('@user_role') == 1)) {
      localStorage.removeItem("@name");
      localStorage.removeItem("@user_role");
      localStorage.removeItem("@user_email");
      navigate("/login");
    }


  }, []);
  const handleLogout = async () => {

    await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/logout", {
      email: localStorage.getItem('@user_email')
    },
      {
        withCredentials: true, // ✅ send cookies/session
      })
      .then(function (response) {
        if (response?.data?.status) {

          localStorage.removeItem("@name");
          localStorage.removeItem("@user_role");
          localStorage.removeItem("@user_email");
          navigate("/login");


        } else {


          Swal.fire({ icon: "error", title: "Logout Failed", text: response?.data?.message });

        }
      })
      .catch(function (error) {

        catchError(error, navigate)
      });


  };


  return (
    <Fragment>


      <div className={isMini ? "layout-fixed sidebar-expand-lg sidebar-mini sidebar-collapse bg-body-tertiary" : "layout-fixed sidebar-expand-lg sidebar-mini sidebar-open bg-body-tertiary"}>
        <div className="app-wrapper">
          <nav className="app-header navbar navbar-expand bg-body">
            <div className="container-fluid">
              <ul className="navbar-nav">


                <li className="nav-item">
                  <a className="nav-link" data-lte-toggle="sidebar" href="#" role="button" onClick={() => setIsMini(!isMini)}>
                    <i className="bi bi-list"></i>
                  </a>
                </li>

              </ul>

              <ul className="navbar-nav ms-auto">
                <li className="nav-item dropdown user-menu">
                  <button
                    className="nav-link dropdown-toggle bg-transparent border-0 d-flex align-items-center"
                    id="userDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="bi bi-person-circle fs-4 me-2"></i>
                    <span className="d-none d-md-inline">{localStorage.getItem("@name")}</span>
                  </button>

                  <ul className="dropdown-menu dropdown-menu-lg dropdown-menu-end" aria-labelledby="userDropdown">
                    {/* User info header */}
                    <li className="bg-light text-center p-3 border-bottom">
                      <p className="mb-0 fw-bold">{localStorage.getItem("@name")}</p>
                      <small className="text-muted">{localStorage.getItem("@user_email")}</small>
                    </li>

                    {/* Action buttons */}
                    <li className=" bg-white px-3 py-2 d-flex justify-content-end">
                     <Link className="btn btn-outline-primary btn-sm me-1" to="/admin/change-password">
                        <i className="bi bi-person-gear me-1"></i> Change Password
                      </Link>
                      <button className="btn btn-outline-danger btn-sm" onClick={handleLogout}>
                        <i className="bi bi-box-arrow-right me-1"></i> Sign out
                      </button>
                    </li>
                  </ul>
                </li>
              </ul>

            </div>
          </nav>

          <aside className="app-sidebar bg-body-secondary shadow" data-bs-theme="dark">
            <div className="sidebar-brand">
              <Link className="brand-link" to="/admin/dashboard">
                <span className="brand-text fw-light" ><img src={logo} /></span>
              </Link>

            </div>
            <div className="sidebar-wrapper">
              <SideMenu />
            </div>
          </aside>

          <Outlet />
          

          <footer className="app-footer">
            <strong>
              Copyright &copy; 2025. <a href={process.env.REACT_APP_URL} className="text-decoration-none">{process.env.REACT_APP_NAME}</a>. All rights reserved


            </strong>
          </footer>
        </div>



      </div>




    </Fragment>
  );
};

export default Layout;
